__turbopack_context__.v({
  "align--left": "tDl0DW_align--left",
  "align--outsideLeft": "tDl0DW_align--outsideLeft",
  "align--outsideRight": "tDl0DW_align--outsideRight",
  "align--right": "tDl0DW_align--right",
  "bgCover": "tDl0DW_bgCover",
  "breakpoint--lg": "tDl0DW_breakpoint--lg",
  "breakpoint--md": "tDl0DW_breakpoint--md",
  "breakpoint--sm": "tDl0DW_breakpoint--sm",
  "breakpoint--xl": "tDl0DW_breakpoint--xl",
  "breakpoint--xsm": "tDl0DW_breakpoint--xsm",
  "breakpoint--xxl": "tDl0DW_breakpoint--xxl",
  "breakpoint--xxxl": "tDl0DW_breakpoint--xxxl",
  "breakpoint--xxxxl": "tDl0DW_breakpoint--xxxxl",
  "container": "tDl0DW_container",
  "contrastNone": "tDl0DW_contrastNone",
  "count--2": "tDl0DW_count--2",
  "count--3": "tDl0DW_count--3",
  "flipX": "tDl0DW_flipX",
  "image": "tDl0DW_image",
  "images": "tDl0DW_images",
  "maskNone": "tDl0DW_maskNone",
  "subtle": "tDl0DW_subtle",
  "variant--featured": "tDl0DW_variant--featured",
});
